import React, { useEffect, useState } from "react";
import { Form, Formik } from "formik";
import * as yup from "yup";
import "./forgotPassword.scss";
import Card from "../../../components/Card/Card";
import InputBlock from "../../../components/InputBlock/InputBlock";
import ButtonMain from "../../../components/ButtonMain/ButtonMain";
import * as api from "../../../services/services";
import { useHistory } from "react-router-dom";
import ButtonBack from "../../../components/ButtonBack/ButtonBack";
import ErrorDialog from "../../../components/ErrorDialog/ErrorDialog";
import Loading from "../../../components/Loading/Loading";
import ModalBox from "../../../components/ModalBox/ModalBox";
import { initRecaptcha } from "../../../services/recaptcha";

const ForgotPassword = () => {
  /////////////////////////////
  // Configuración del componente
  /////////////////////////////

  const [error, setError] = useState();

  const [loading, setLoading] = useState(false);
  const history = useHistory();
  const [reciveSms, setReciveSms] = useState(false)

  // Precarga reCAPTCHA para que el token ya esté disponible al enviar el formulario
  useEffect(() => {
    initRecaptcha();
  }, []);

  /////////////////////////////
  // Gestión de eventos y servicios
  /////////////////////////////

  /**
   *
   * @param {object} values
   * @description Gestiona la respuesta de onSubmitForgetPassword
   * Independientemente de la respuesta del servidor muestra siempre el mismo mensaje
   * (para no revelar si el DNI está registrado) y redirecciona a /login
   *
   */

  const handleSubmit = async (values) => {
    setLoading(true);
    try {
      await api.forgotPassword(values);
    } catch (error) {
      // Se ignora el código de error intencionadamente
    } finally {
      setLoading(false);
      setReciveSms(true);
      setTimeout(() => {
        history.push("/intro/login");
      }, 5000);
    }
  };

  /////////////////////////////
  // Funciones de renderizado
  /////////////////////////////

  /**
   *
   * @description Esquema de validación del formulario
   * @see {renderFormik}
   *
   */

  const validationSchema = yup.object({
    dni: yup
      .string()
      .required("El campo NIF/NIE es obligatorio")
      .matches(
        /^((([X-Z])|([LM])){1}([-]?)([0-9]{7})([-]?)([a-zA-Z]{1}))|(([0-9]{8})([-]?)([a-zA-Z]))/,
        "El formato de NIF/NIE es incorrecto"
      ),
  });

  /**
   *
   * @description Si hay un error devuelve un mensaje
   *
   */

  const renderErrors = () => (error ? <ErrorDialog text={error} /> : null);

  /**
   *
   * @returns {Component}
   * @description Genera un componente formulario con la librería Formik que valida los
   * valores User y Password
   *
   */

  const renderFormik = () => {
    return (
      <React.Fragment>
        {loading ? (
          <Loading />
        ) : (
          <React.Fragment>
            {/* Título */}
            <h1>¿Has olvidado tu contraseña?</h1>
            {renderErrors()}
            <Formik
              initialValues={{ dni: "" }}
              validationSchema={validationSchema}
              onSubmit={(values, actions) => {
                actions.resetForm();
                handleSubmit(values);
              }}
            >
              {(props) => (
                <Form onSubmit={props.onSubmit} className="form-container">
                  <p>
                    Introduce tu número de identificación (NIF o NIE) y te enviaremos un SMS con las instrucciones para
                    reactivar tu contraseña.
                  </p>
                  <div
                    className="form-group"
                    onClick={() => {
                      if (error) {
                        setError(null);
                      }
                    }}
                  >
                    <InputBlock
                      label="NIF/NIE"
                      type="text"
                      placeholder="Ejemplo 00000000X"
                      handleChange={props.handleChange}
                      paramChange="dni"
                      values={props.values.dni}
                      handleBlur={props.handleBlur}
                      paramBlur="dni"
                    />
                  </div>

                  {props.touched.dni && props.errors.dni ? <ErrorDialog text={props.errors.dni} /> : null}

                  <ButtonMain
                    label="Continuar"
                    iconClass="arrow-right-white"
                    action={props.handleSubmit}
                    type="submit"
                  />
                </Form>
              )}
            </Formik>
          </React.Fragment>
        )}
      </React.Fragment>
    );
  };

  /////////////////////////////
  // Renderizado del componente
  /////////////////////////////

  /***
   *
   * @return {Component}
   * @see {renderFormik}
   * @description Render el formulario de Formik
   *
   */

  return (
    <Card customClass="forgot-card">
      <ButtonBack />
      {reciveSms && <ModalBox onToggle={()=>setReciveSms(false)}>
				<div className="success-text"  style={{maxWidth: "80vw"}}>Si estás registrado, recibirás un SMS para completar el cambio de contraseña</div>
			</ModalBox>}
      {renderFormik()}
    </Card>
  );
};

export default ForgotPassword;
